import IntlWrapper from 'components/layout/intlWrapper';
import React from 'react';
import ReactDOM from 'react-dom';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {getPrivacyPolicy} from 'api/info.jsx';
import events from 'lib/events';

// Libs
import router from '../../lib/router.js';
// Register in router
let isMounted = false;
let render = container => {
  if(!isMounted) {
    console.info('[UI.page.privacy-policy] rendering page', isMounted);
    ReactDOM.render(<IntlWrapper><PrivacyPolicy /></IntlWrapper>, container);
  }
};

console.info('[UI.page.privacy-policy] register route');
router.rr.add([{path: 'privacy-policy/*sub', handler: render}]);
router.rr.add([{path: 'privacy-policy', handler: render}]);

// helper
const replaceAll = (target, search, replacement) => target.split(search).join(replacement);

// Page object
class PrivacyPolicy extends React.Component {
  static displayName = 'PrivacyPolicy';

  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {loading: true, article: ''};

  componentWillMount() {
    this.fetchData();

    this.unsub = events.subscribe('set.language', this.fetchData);
  }

  componentWillUnmount() {
    if (this.unsub && this.unsub.remove) {
      this.unsub.remove();
    }
  }

  fetchData = () =>
    getPrivacyPolicy(this.props.intl.locale)
      .then(x => this.setState({article: x, loading: false}))
      .catch(err => {
        console.error(err);
        this.setState({loading: false});
      });

  render() {
    if (!this.state.loading && !this.state.article) {
      return <div className='container'>
        <h1><FormattedMessage id="general.terms.use"/></h1>
        <p><FormattedMessage id='article.load.failed' /></p>
      </div>;
    }

    let txt = replaceAll(this.state.article, 'name="', 'name="privacy-policy/');

    txt = replaceAll(txt, 'href="#', 'href="#privacy-policy/');

    let article = {
      __html: txt,
    };

    return <div className='container'>
      <h1><FormattedMessage id="general.privacy.policy"/></h1>
      <div dangerouslySetInnerHTML={article}/>
    </div>;
  }
}

export default injectIntl(PrivacyPolicy);
